interface GuidanceTemplateVariable {
  key: string;
  label: string;
  description: string;
}

export const GUIDANCE_TEMPLATE_VARIABLES: GuidanceTemplateVariable[] = [
  { key: "project_name", label: "Project", description: "The project's name" },
  { key: "demand_name", label: "Demand", description: "The project's demand name" },
  {
    key: "auditor_name",
    label: "Auditor",
    description: "The name of the auditor selected in the pop-up",
  },
  {
    key: "guidance",
    label: "Guidance",
    description: "The number of hours entered in the pop-up's Guidance field",
  },
];

export const DEFAULT_GUIDANCE_REQUEST_TEMPLATE = `Requesting guidance on {{project_name}} ({{demand_name}}).

Auditor: {{auditor_name}}
Estimated hours: {{guidance}}

Please advise on next steps.`;

interface GuidanceTemplateValues {
  project_name?: string;
  demand_name?: string;
  auditor_name?: string;
  guidance?: string;
}

/**
 * Replaces {{variable_name}} tokens with the matching value. A token with no
 * (or blank) value is left untouched so the user can see which placeholders
 * still need to be filled in as they make selections.
 */
export function renderGuidanceTemplate(template: string, values: GuidanceTemplateValues): string {
  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key: string) => {
    const value = values[key as keyof GuidanceTemplateValues];
    return value && value.trim() !== "" ? value : match;
  });
}
